











































































import { Component, Vue } from 'vue-property-decorator'
import { Message, MessageBox } from 'element-ui'
import {
  GetUserCheckinConfig,
  SaveUserCheckinConfig,
  ListUserCheckinSpecialReward,
  SaveUserCheckinSpecialReward,
  DeleteUserCheckinSpecialReward,
} from '@/api'

interface CheckinConfigState {
  enabled: boolean
  baseActivityQty: number
  streakLadderJson: string
  note: string
}

interface StreakStep {
  minDays: number
  multiplier: number
}

interface StreakState {
  enabled: boolean
  steps: StreakStep[]
}

interface SpecialDateReward {
  rewardDate: string
  enabled: boolean
  activityQty: number
  contributionQty: number
  energyQty: number
  mungBeanQty: number
  pointsQty: number
  note: string
}

function isStreakRow(v: unknown): v is { minDays?: number; multiplier?: number } {
  return typeof v === 'object' && v !== null
}

@Component({})
export default class UserCheckinConfig extends Vue {
  private config: CheckinConfigState = {
    enabled: true,
    baseActivityQty: 0,
    streakLadderJson: '',
    note: '',
  }
  private streak: StreakState = {
    enabled: false,
    steps: [],
  }

  private specialList: SpecialDateReward[] = []
  private specialDialogVisible = false
  private specialForm: SpecialDateReward = {
    rewardDate: '',
    enabled: true,
    activityQty: 0,
    contributionQty: 0,
    energyQty: 0,
    mungBeanQty: 0,
    pointsQty: 0,
    note: '',
  }

  public created(): void {
    this.load()
  }

  private async load(): Promise<void> {
    const cfg = await GetUserCheckinConfig()
    if (cfg) {
      const c = cfg as {
        enabled?: boolean
        baseActivityQty?: number
        streakLadderJson?: string
        note?: string
      }
      this.config.enabled = !!c.enabled
      this.config.baseActivityQty = Number(c.baseActivityQty || 0)
      this.config.streakLadderJson = c.streakLadderJson || ''
      this.config.note = c.note || ''
    }
    this.loadStreakFromJson(this.config.streakLadderJson)
    const list = await ListUserCheckinSpecialReward({})
    this.specialList = (list as SpecialDateReward[]) || []
  }

  private async saveConfig(): Promise<void> {
    const streakLadderJson = this.buildStreakJson()
    await SaveUserCheckinConfig({
      enabled: this.config.enabled,
      baseActivityQty: this.config.baseActivityQty,
      streakLadderJson,
      note: this.config.note,
    })
    Message.success('保存成功')
    this.load()
  }

  private addStreakStep(): void {
    if (!this.streak.steps) this.streak.steps = []
    this.streak.steps.push({ minDays: 1, multiplier: 1 })
  }

  private removeStreakStep(idx: number): void {
    if (!this.streak.steps) return
    this.streak.steps.splice(idx, 1)
  }

  private loadStreakFromJson(json: string): void {
    this.streak.enabled = false
    this.streak.steps = []
    if (!json) return
    try {
      const o = JSON.parse(json) as { steps?: unknown }
      const raw = Array.isArray(o.steps) ? o.steps : []
      const norm: StreakStep[] = raw
        .filter((s: unknown) => isStreakRow(s))
        .map((s) => {
          const row = s as { minDays?: number; multiplier?: number }
          return { minDays: Number(row.minDays || 0), multiplier: Number(row.multiplier || 0) }
        })
        .filter((s) => s.minDays > 0 && s.multiplier > 0)
        .sort((a, b) => a.minDays - b.minDays)
      if (norm.length > 0) {
        this.streak.enabled = true
        this.streak.steps = norm
      }
    } catch {
      // 忽略非 JSON/格式异常
    }
  }

  private buildStreakJson(): string {
    if (!this.streak.enabled) return ''
    const steps = (this.streak.steps || [])
      .map((s) => ({ minDays: Number(s.minDays || 0), multiplier: Number(s.multiplier || 0) }))
      .filter((s) => s.minDays > 0 && s.multiplier > 0)
      .sort((a, b) => a.minDays - b.minDays)
    if (steps.length === 0) return ''
    return JSON.stringify({ steps })
  }

  private openEditSpecial(row?: SpecialDateReward): void {
    if (!row) {
      this.specialForm = {
        rewardDate: '',
        enabled: true,
        activityQty: 0,
        contributionQty: 0,
        energyQty: 0,
        mungBeanQty: 0,
        pointsQty: 0,
        note: '',
      }
    } else {
      this.specialForm = { ...row }
    }
    this.specialDialogVisible = true
  }

  private async saveSpecial(): Promise<void> {
    if (!this.specialForm.rewardDate) {
      Message.warning('请选择日期')
      return
    }
    await SaveUserCheckinSpecialReward(this.specialForm)
    Message.success('保存成功')
    this.specialDialogVisible = false
    this.load()
  }

  private async removeSpecial(row: SpecialDateReward): Promise<void> {
    await MessageBox.confirm(`确认删除 ${row.rewardDate} 的特殊奖励？`, '提示', { type: 'warning' })
    await DeleteUserCheckinSpecialReward({ rewardDate: row.rewardDate })
    Message.success('删除成功')
    this.load()
  }
}
